import { Button } from "@mui/material";

export default function RestartButton({ onRestart }) {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={onRestart}
      sx={{
        alignSelf: "center",
        mt: 1,
        px: 4,
        py: 1.25,
        borderRadius: 999,
        color: "#03263e",
        boxShadow: "0 16px 32px rgba(142, 202, 230, 0.24)",
      }}
    >
      Restart Game
    </Button>
  );
}
